// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 97 ? "bsd-ui" : chunkId) + "-" + {"97":"c4795c38c7fd2e6476de","602":"1cdff66f54a4235e91eb"}[chunkId] + ".css";
};